module.exports = __webpack_public_path__ + "images/podcast/podcast_header_image.jpg";